export interface AdminPortalConfig {
  /** OIDC authority — the Drawboard Projects identity server, e.g. https://projects.sso.drawboard.com */
  authority: string;
  /** OIDC client id. We reuse the existing `web_client` SPA client (no extra Duende client). */
  clientId: string;
  /** Base URL of DBCloud.WebAPI, e.g. https://api.projects.drawboard.com */
  apiBaseUrl: string;
  /** Base URL of DBCloud.AdminPortalApi (the admin-portal's own backend, e.g. https://admin-api.projects.drawboard.com). */
  adminApiBaseUrl: string;
  /** The user-gated scope this portal requests. The identity server only grants it to admins. */
  adminScope: string;
  /** Human-readable environment label shown in the status bar, e.g. "us-prod-prod". */
  environmentName: string;
}

declare global {
  interface Window {
    __ADMIN_PORTAL_CONFIG__?: Partial<AdminPortalConfig>;
  }
}

function required(value: string | undefined, key: string): string {
  if (!value) {
    throw new Error(`Admin portal misconfigured: window.__ADMIN_PORTAL_CONFIG__.${key} is missing (check env.js)`);
  }
  return value.replace(/\/+$/, "");
}

const raw = window.__ADMIN_PORTAL_CONFIG__ ?? {};

export const config: AdminPortalConfig = {
  authority: required(raw.authority, "authority"),
  clientId: required(raw.clientId, "clientId"),
  apiBaseUrl: required(raw.apiBaseUrl, "apiBaseUrl"),
  adminApiBaseUrl: required(raw.adminApiBaseUrl, "adminApiBaseUrl"),
  adminScope: raw.adminScope?.trim() || "projects-admin",
  environmentName: raw.environmentName?.trim() || "unknown",
};

export const ADMIN_ROLE = "drawboard-admin";

/** Hardcoded server-side too — only staff emails may hold admin-portal access or be targeted by support actions. */
export const ALLOWED_ADMIN_EMAIL_DOMAIN = "@drawboard.com";

export function isAllowedAdminEmail(email: string): boolean {
  return email.trim().toLowerCase().endsWith(ALLOWED_ADMIN_EMAIL_DOMAIN);
}
